
import moment from 'moment'
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setIsLoadingMore(state, isLoadingMore) {
    state.isLoadingMore = isLoadingMore
  },
  setIsImageUploading(state, isLoading) {
    state.isImageUploading = isLoading
  },
  setIsControls(state, isControls) {
    state.isControls = isControls
  },
  updateIsFiltersApplied(state, payload) {
    state.isFiltersApplied = payload
  },
  updateModalForm(state, payload) {
    state.modalForm = {
      ...state.modalForm,
      ...payload
    }
  },
  setFiltersCollection(state, filtersCollection) {
    state.filtersCollection = filtersCollection
  },
  setCollection(state, collection) {
    state.collection = collection
  },
  updateCollection(state, collection) {
    state.collection = [
      ...state.collection,
      ...collection
    ]
  },
  setPagination(state, pagination) {
    state.pagination = pagination
  },
  setInitialState(state) {
    this.state.sale = {
      ...initialState()
    }
  },
  clearEditForm(state) {
    state.editForm = initialState().editForm
  },
  updateIsModalFormLoading(state, isLoading) {
    state.isModalFormLoading = isLoading
  },
  setEditForm(state, payload) {
    state.editForm = {
      ...state.editForm,
      ...payload,
      searchDate: moment.unix(payload.searchDate).format('DD.MM.YYYY'),
      validityFrom: moment.unix(payload.validityFrom).format('DD.MM.YYYY'),
      validityTo: moment.unix(payload.validityTo).format('DD.MM.YYYY'),
    }
  },
  setVisibilitySettingsType(state, type) {
    state.visibilitySettingsType = type
  },
  setEditableNowSaleId(state, id) {
    state.editableNowSaleId = id
  },
  setModalFormMessage(state, message) {
    state.modalForm = {
      ...state.modalForm,
      showContent: false,
      message
    }

    setTimeout(() => {
      state.modalForm = initialState().modalForm
    }, 2000)
  },
  resetDateAndShift(state) {
    const {
      searchDate,
      extraDays
    } = initialState().editForm

    state.editForm = {
      ...state.editForm,
      searchDate,
      extraDays
    }
  }
}

export default mutations